import OSlateEditor from '@/libs/slate-editor'
import { Terms } from '@/services/terms/terms.model'
import { Modal, ModalProps, Typography } from 'antd'
import React, { useState } from 'react'
import ReactDOM from 'react-dom'

interface TermsModalProps extends ModalProps {
  terms: Terms.Info
}

function TermsModal(props: TermsModalProps) {
  const { terms, ...modalProps } = props
  const [isVisible, setIsVisible] = useState(true)

  if (!terms) {
    return null
  }

  return (
    (<Modal
      {...modalProps}
      open={isVisible}
      onOk={(e) => {
        setIsVisible(false)
        modalProps.onOk?.(e)
      }}
      onCancel={(e) => {
        setIsVisible(false)
        modalProps.onCancel?.(e)
      }}
      okText={modalProps.okText || 'OK'}
    >
      <Typography.Title level={4}>{terms.name}</Typography.Title>
      <OSlateEditor value={terms.content} readOnly={true} />
    </Modal>)
  );
}

TermsModal.show = (props: TermsModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <TermsModal
      {...props}
      afterClose={() => {
        props.afterClose?.()
        clean()
      }}
    />,
    div
  )
}

export default TermsModal
